import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useInvoiceStatusHandler from "hooks/invoice/useInvoiceStatusHandler";
import React from "react";
export default function TabInvoiceBtn(param) {
    var tab = param.tab, setTab = param.setTab;
    var showPaymentContent = useInvoiceStatusHandler().showPaymentContent;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-3 pagezoom",
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "btn btn-st-3 me-3",
                style: tab != 1 ? {
                    background: "transparent",
                    border: 0,
                    color: "#9C9C9C"
                } : {},
                onClick: function() {
                    return setTab(1);
                },
                children: "ข้อมูลสินค้า"
            }),
            showPaymentContent && /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "btn btn-st-3",
                style: tab != 2 ? {
                    background: "transparent",
                    border: 0,
                    color: "#9C9C9C"
                } : {},
                onClick: function() {
                    return setTab(2);
                },
                children: "การรับชำระ"
            })
        ]
    });
}
